import { connect, useDispatch } from 'react-redux';
import React, { useState, useEffect } from 'react';

import './style.scss';
import currency from 'currency.js';
import moment from 'moment';
import { ROLES } from '../../../utils/constants';
import { Button, CircularProgress, IconButton } from '@mui/material';
import { useHistory } from 'react-router';
import CountDownTimer from '../../CountDownTimer';
import { setUser } from '../../../../redux/actions';
import { refetchPromotion } from '../../../../redux/actions/promotions';

const SubscriptionPriceWidget = ({
    user,
    refetch,
}) => {
    const history = useHistory();
    const dispatch = useDispatch();

    const [timeLeft, setTimeLeft] = useState(0);
    const [promotion, setPromotion] = useState({});
    const [busy, setBusy] = useState(false);
    const [oldSaving, setOldSaving] = useState(0);
    const [hasPrevious, setHasPrevious] = useState(false);

    useEffect(() => {
        let mounted = true;
        if (user && Object.keys(user).length > 0 && user.role == ROLES.PU && user.creator && user.creator.promo_details && user.creator.promo_details.promo_duration != 0) {
            const duration = moment.utc(user.creator.promo_details.promo_start)
                .local()
                .add(user.creator.promo_details.promo_duration, 'hours');
            setTimeLeft(duration);
        } else {
            setTimeLeft('No limit');
        }

        if (user.creator && Object.keys(promotion).length <= 0 && (!user.creator.promo_details || Object.keys(user.creator.promo_details).length <= 0)) {
            getPromotion();
        }

        return () => {
            mounted = false;
        };
    }, [user]);

    useEffect(() => {
        if (Object.keys(promotion).length > 0) {
            if (promotion.promo_price > 0) {
                setHasPrevious(true);
                let percentage = 100 - ((parseFloat(promotion.promo_price) / parseFloat(user.creator.subscription_price)) * 100);
                percentage = Math.round(percentage / 5) * 5;
                setOldSaving(percentage == 100 ? 95 : percentage);
            } else {
                setHasPrevious(false);
            }
        }
    }, [promotion]);

    const getPromotion = async () => {
        setBusy(true);
        await axios.get('/api/promotions')
            .then(response => {
                setPromotion(response.data);
                setBusy(false);
            })
            .catch(error => {
                setBusy(false);
                console.error(error);
            });
    };

    const RenderGoToPromotionButton = () => {
        return <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
                variant='text'
                size='small'
                onClick={() => {}}
                sx={{ padding: '8px' }}
                title='Edit Promotion'
            >
                <i className="fa-sharp fa-solid fa-chevron-right"></i>
            </Button>
        </div>;
    };

    const handleEndTime = () => {
        // getPromotion();
    };

    useEffect(() => {
        if (refetch) {
            dispatch(setUser());
            dispatch(refetchPromotion(false));
        }
    }, [refetch]);

    return <div className='subscription-price-widget'>
        {
            user && user.creator && Object.keys(user.creator).length > 0
                ? <p>
                    My Subscription Price: <strong><span className="blue_text">{currency(user.creator.subscription_price).format({ precession: 0 })}</span>/month</strong>
                </p>
                : null
        }

        {
            busy
                ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '8px' }}>
                    <CircularProgress size={20} />
                </div>
                : null
        }

        {
            !busy && user.creator && user.creator.promo_details && Object.keys(user.creator.promo_details).length > 0
                ? <div className='subscription-price-widget__promotion' onClick={() => history.push('/promotion')}>
                    Current Promotion<br />
                    <strong style={{ color: '#0097fe' }}>Limited Offer {user.creator.promo_details.save}% off! {currency(user.creator.promo_details.promo_price).format({ precession: 2 })} USD for 1 month</strong><br />
                    {timeLeft != 'No limit'
                        ? <React.Fragment>Promo ends: <span className="blue_text">
                            <CountDownTimer
                                dateTime={timeLeft}
                                isUTC={false}
                                onEndTime={handleEndTime}
                            />
                        </span><br /></React.Fragment>
                        : null}
                    New Subscribers: <span className="blue_text mr-3">{user.creator.promo_details.promo_limit_used}</span><br />
                    Promos left: <span className="blue_text">
                        {
                            user.creator.promo_details.promo_limit == 0
                                ? 'Unlimited'
                                : parseInt(user.creator.promo_details.promo_limit) - parseInt(user.creator.promo_details.promo_limit_used)
                        }</span>
                    <RenderGoToPromotionButton />
                </div>
                : null
        }

        {
            // has existing promotion but not active
            !busy && hasPrevious && promotion && Object.keys(promotion).length > 0 && (user.creator && Object.keys(user.creator.promo_details).length <= 0)
                ? <div className='subscription-price-widget__promotion' onClick={() => history.push('/promotion')}>
                    Last Promotion<br />
                    <strong style={{ color: '#0097fe' }}>Limited Offer {oldSaving}% off! {currency(promotion.promo_price).format({ precession: 2 })} USD for 1 month</strong><br />
                    Promo status: <em>Finished</em><br />
                    Subscriptions: {promotion.promo_limit_used} out of {promotion.promo_limit == 0 ? 'Unlimited' : promotion.promo_limit}
                    <RenderGoToPromotionButton />
                </div>
                : null
        }

        {
            // has existing promotion and active
            !busy && !hasPrevious && promotion && (user.creator && Object.keys(user.creator.promo_details).length <= 0)
                ? <div className='subscription-price-widget__promotion d-flex' onClick={() => history.push('/promotion')}>
                    <span>
                        Promotions and Free Trials and Discount Links
                    </span>
                    <RenderGoToPromotionButton />
                </div>
                : null
        }

    </div>;
};

const mapStateToProps = state => ({
    user: state.user.user,
    refetch: state.promotions.refetch
});

export default connect(mapStateToProps)(SubscriptionPriceWidget);